module.exports = __webpack_public_path__ + "static/media/29ADMSPC33.794aee32.jpg";